import { DialogTitle } from "lib/headlessui/components/dialog/dialog";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";

interface ResponsivePanelDesktopHeaderProps {
    headerText: string;
    onDismiss: () => void;
}

export const ResponsivePanelDesktopHeader: React.FC<
    ResponsivePanelDesktopHeaderProps
> = ({ headerText, onDismiss }) => {
    return (
        <div className="px-4 sm:px-6">
            <div className="flex items-start justify-between">
                <DialogTitle className="text-lg font-medium text-gray-900">
                    {headerText}
                </DialogTitle>
                <div className="ml-3 flex h-7 items-center">
                    <button
                        type="button"
                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-brand-500"
                        onClick={onDismiss}>
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    );
};
